(function () {
  const mount = document.getElementById("bb-meal-plan-builder");
  if (!mount) return;

  mount.innerHTML = `
    <div class="bbmp">
      <div class="bbmp-shell">
        <div class="bbmp-topbar">
          <div>
            <p class="bbmp-kicker">Bar Benders</p>
            <h2>Meal Plan Builder</h2>
          </div>
          <button type="button" class="bbmp-ghost" id="bbmp-start-over-top">Start Over</button>
        </div>

        <div class="bbmp-progress-wrap">
          <div class="bbmp-progress-label">
            <span id="bbmp-step-label">Step 1 of 5</span>
            <span id="bbmp-save-status">Saved in this browser</span>
          </div>
          <div class="bbmp-progress">
            <div id="bbmp-progress-fill"></div>
          </div>
        </div>

        <div id="bbmp-saved-banner" class="bbmp-saved-banner" hidden>
          <div>
            <strong>Saved plan found.</strong>
            <span>Continue where you left off or start fresh.</span>
          </div>
          <div class="bbmp-banner-actions">
            <button type="button" class="bbmp-btn bbmp-btn-small" id="bbmp-continue-saved">Continue</button>
            <button type="button" class="bbmp-ghost bbmp-btn-small" id="bbmp-clear-saved">Start Fresh</button>
          </div>
        </div>

        <form id="bbmp-form">
          <section class="bbmp-screen active" data-screen="0">
            <div class="bbmp-screen-head">
              <p class="bbmp-kicker">Step 1</p>
              <h3>Choose Your Goal</h3>
              <p>Pick the direction. The plan will build around it.</p>
            </div>

            <div class="bbmp-card-grid two">
              <button type="button" class="bbmp-choice" data-choice="goal" data-value="bulk">
                <span class="bbmp-choice-title">Bulk</span>
                <span class="bbmp-choice-text">Gain size with a structured surplus and meals built around your goal weight.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="goal" data-value="cut">
                <span class="bbmp-choice-title">Cut</span>
                <span class="bbmp-choice-text">Get lean with high protein, controlled calories, and simple meals.</span>
              </button>
            </div>
          </section>

          <section class="bbmp-screen" data-screen="1">
            <div class="bbmp-screen-head">
              <p class="bbmp-kicker">Step 2</p>
              <h3>Your Stats</h3>
              <p>Keep it simple. The app only asks for what it needs.</p>
            </div>

            <div class="bbmp-fields">
              <label class="bbmp-field">
                <span>Current Bodyweight</span>
                <div class="bbmp-input-wrap">
                  <input id="bbmp-current-weight" type="number" min="80" max="600" placeholder="220">
                  <span>lb</span>
                </div>
              </label>

              <label class="bbmp-field bbmp-bulk-only">
                <span>Goal Bodyweight</span>
                <div class="bbmp-input-wrap">
                  <input id="bbmp-goal-weight" type="number" min="80" max="600" placeholder="235">
                  <span>lb</span>
                </div>
              </label>

              <div class="bbmp-field bbmp-cut-only">
                <span>Estimate Your Body Fat %</span>
                <div class="bbmp-pill-row">
                  <button type="button" class="bbmp-pill" data-choice="bodyFat" data-value="30+">30%+</button>
                  <button type="button" class="bbmp-pill" data-choice="bodyFat" data-value="20-30">20 to 30%</button>
                  <button type="button" class="bbmp-pill" data-choice="bodyFat" data-value="10-20">10 to 20%</button>
                </div>
              </div>

              <div class="bbmp-field">
                <span>Activity Level</span>
                <div class="bbmp-card-grid four compact">
                  <button type="button" class="bbmp-choice mini" data-choice="activity" data-value="low">
                    <span>Low</span>
                    <small>Low movement</small>
                  </button>
                  <button type="button" class="bbmp-choice mini" data-choice="activity" data-value="moderate">
                    <span>Moderate</span>
                    <small>Normal activity</small>
                  </button>
                  <button type="button" class="bbmp-choice mini" data-choice="activity" data-value="high">
                    <span>High</span>
                    <small>Active lifestyle</small>
                  </button>
                  <button type="button" class="bbmp-choice mini" data-choice="activity" data-value="veryHigh">
                    <span>Very High</span>
                    <small>Physical job</small>
                  </button>
                </div>
              </div>

              <label class="bbmp-field">
                <span>Training Days Per Week</span>
                <select id="bbmp-training-days">
                  <option value="3">3 days</option>
                  <option value="4">4 days</option>
                  <option value="5" selected>5 days</option>
                  <option value="6">6 days</option>
                  <option value="7">7 days</option>
                </select>
              </label>

              <label class="bbmp-field">
                <span>Meals Per Day</span>
                <select id="bbmp-meal-count">
                  <option value="3">3 meals</option>
                  <option value="4">4 meals</option>
                  <option value="5" selected>5 meals</option>
                  <option value="6">6 meals</option>
                </select>
              </label>
            </div>
          </section>

          <section class="bbmp-screen" data-screen="2">
            <div class="bbmp-screen-head">
              <p class="bbmp-kicker">Step 3</p>
              <h3>Choose How You Eat</h3>
              <p>Pick the diet style that is most realistic for you to follow.</p>
            </div>

            <div class="bbmp-card-grid two diet-grid">
              <button type="button" class="bbmp-choice" data-choice="diet" data-value="standard">
                <span class="bbmp-choice-title">Bar Benders Standard</span>
                <span class="bbmp-choice-text">Meat, eggs, rice, potatoes, oats, Greek yogurt, fruit, and whole foods.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="oldSchool">
                <span class="bbmp-choice-title">Old School Bodybuilder</span>
                <span class="bbmp-choice-text">Classic bodybuilding staples: chicken, beef, eggs, tuna, rice, potatoes, oats, and dairy.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="budget">
                <span class="bbmp-choice-title">Budget Bodybuilder</span>
                <span class="bbmp-choice-text">Cheap, repeatable staples that get the job done.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="highCarb">
                <span class="bbmp-choice-title">High Carb Performance</span>
                <span class="bbmp-choice-text">More carbs for hard training, better pumps, and better output.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="lowCarb">
                <span class="bbmp-choice-title">Low Carb Bodybuilder</span>
                <span class="bbmp-choice-text">Higher protein, higher fat, lower carb meals.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="animal">
                <span class="bbmp-choice-title">Animal-Based</span>
                <span class="bbmp-choice-text">Meat, eggs, dairy, fruit, honey, rice, and potatoes.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="plant">
                <span class="bbmp-choice-title">Plant-Based Bodybuilder</span>
                <span class="bbmp-choice-text">Tofu, tempeh, seitan, beans, lentils, pea protein, oats, rice, and potatoes.</span>
              </button>

              <button type="button" class="bbmp-choice" data-choice="diet" data-value="picky">
                <span class="bbmp-choice-title">Simple Picky Eater</span>
                <span class="bbmp-choice-text">Plain meals. Minimal ingredients. Easy to repeat.</span>
              </button>
            </div>
          </section>

          <section class="bbmp-screen" data-screen="3">
            <div class="bbmp-screen-head">
              <p class="bbmp-kicker">Step 4</p>
              <h3>Customize It</h3>
              <p>Choose what you want included and what you want avoided.</p>
            </div>

            <div class="bbmp-pref-block">
              <h4>Foods You Want Included</h4>
              <div id="bbmp-include-foods" class="bbmp-chip-row"></div>
            </div>

            <div class="bbmp-pref-block">
              <h4>Foods To Avoid</h4>
              <div id="bbmp-avoid-foods" class="bbmp-chip-row"></div>
            </div>

            <div class="bbmp-pref-block">
              <h4>Prep Style</h4>
              <div class="bbmp-card-grid four compact">
                <button type="button" class="bbmp-choice mini" data-choice="prep" data-value="mealPrep">
                  <span>Meal Prep</span>
                  <small>Repeatable</small>
                </button>
                <button type="button" class="bbmp-choice mini" data-choice="prep" data-value="fresh">
                  <span>Cook Fresh</span>
                  <small>More variety</small>
                </button>
                <button type="button" class="bbmp-choice mini" data-choice="prep" data-value="minimal">
                  <span>Minimal Cooking</span>
                  <small>Easy foods</small>
                </button>
                <button type="button" class="bbmp-choice mini" data-choice="prep" data-value="cheap">
                  <span>Cheapest</span>
                  <small>Budget first</small>
                </button>
              </div>
            </div>
          </section>

          <section class="bbmp-screen" data-screen="4">
            <div class="bbmp-screen-head">
              <p class="bbmp-kicker">Step 5</p>
              <h3>Your Meal Plan</h3>
              <p>Built from your goal, stats, diet style, and preferences.</p>
            </div>

            <div id="bbmp-results"></div>
          </section>

          <div class="bbmp-nav">
            <button type="button" class="bbmp-ghost" id="bbmp-back">Back</button>
            <button type="button" class="bbmp-btn" id="bbmp-next">Continue</button>
          </div>
        </form>
      </div>
    </div>
  `;

  const root = mount;

  const CONFIG = {
    bulkBaseMultiplier: 16,
    activity: {
      low: { label: "Low", multiplier: 0.95 },
      moderate: { label: "Moderate", multiplier: 1 },
      high: { label: "High", multiplier: 1.075 },
      veryHigh: { label: "Very High", multiplier: 1.15 }
    },
    saveKey: "bbMealPlanBuilderV2"
  };

  const state = {
    step: 0,
    goal: "",
    currentWeight: "",
    goalWeight: "",
    bodyFat: "20-30",
    activity: "moderate",
    trainingDays: "5",
    mealCount: "5",
    diet: "standard",
    includeFoods: [],
    avoidFoods: [],
    prep: "mealPrep",
    result: null
  };

  const foodChips = [
    "Beef",
    "Chicken",
    "Eggs",
    "Rice",
    "Potatoes",
    "Oats",
    "Greek Yogurt",
    "Fruit",
    "Fish",
    "Cottage Cheese",
    "Protein Powder",
    "Milk",
    "Beans",
    "Tofu"
  ];

  const foods = [
    { name: "Chicken Breast", key: "Chicken", serving: "4 oz cooked", amountBase: 4, unit: "oz", cal: 185, p: 35, c: 0, f: 4, cat: "protein", diets: ["standard", "oldSchool", "budget", "highCarb", "lowCarb", "picky"] },
    { name: "Chicken Thighs", key: "Chicken", serving: "4 oz cooked", amountBase: 4, unit: "oz", cal: 230, p: 28, c: 0, f: 13, cat: "protein", diets: ["standard", "budget", "lowCarb", "animal", "picky"] },
    { name: "Lean Ground Beef", key: "Beef", serving: "4 oz cooked", amountBase: 4, unit: "oz", cal: 220, p: 30, c: 0, f: 11, cat: "protein", diets: ["standard", "oldSchool", "budget", "lowCarb", "animal", "picky"] },
    { name: "Sirloin Steak", key: "Beef", serving: "4 oz cooked", amountBase: 4, unit: "oz", cal: 240, p: 33, c: 0, f: 12, cat: "protein", diets: ["standard", "oldSchool", "lowCarb", "animal"] },
    { name: "Whole Eggs", key: "Eggs", serving: "2 large eggs", amountBase: 2, unit: "eggs", cal: 140, p: 12, c: 1, f: 10, cat: "protein", diets: ["standard", "oldSchool", "budget", "lowCarb", "animal", "picky"] },
    { name: "Egg Whites", key: "Eggs", serving: "1 cup", amountBase: 1, unit: "cup", cal: 126, p: 26, c: 2, f: 0, cat: "protein", diets: ["standard", "oldSchool", "highCarb", "picky"] },
    { name: "Tuna", key: "Fish", serving: "1 can", amountBase: 1, unit: "can", cal: 120, p: 26, c: 0, f: 1, cat: "protein", diets: ["standard", "oldSchool", "budget", "highCarb", "picky"] },
    { name: "Salmon", key: "Fish", serving: "4 oz cooked", amountBase: 4, unit: "oz", cal: 235, p: 25, c: 0, f: 14, cat: "protein", diets: ["standard", "lowCarb", "animal"] },
    { name: "Greek Yogurt", key: "Greek Yogurt", serving: "170g", amountBase: 170, unit: "g", cal: 100, p: 17, c: 6, f: 0, cat: "protein", diets: ["standard", "oldSchool", "budget", "highCarb", "animal", "picky"] },
    { name: "Cottage Cheese", key: "Cottage Cheese", serving: "1 cup", amountBase: 1, unit: "cup", cal: 180, p: 25, c: 8, f: 5, cat: "protein", diets: ["standard", "oldSchool", "budget", "animal"] },
    { name: "Whey Protein", key: "Protein Powder", serving: "1 scoop", amountBase: 1, unit: "scoop", cal: 120, p: 24, c: 3, f: 2, cat: "protein", diets: ["standard", "oldSchool", "budget", "highCarb", "lowCarb", "picky"] },
    { name: "Pea Protein", key: "Protein Powder", serving: "1 scoop", amountBase: 1, unit: "scoop", cal: 120, p: 24, c: 2, f: 2, cat: "protein", diets: ["plant"] },
    { name: "Tofu", key: "Tofu", serving: "200g", amountBase: 200, unit: "g", cal: 190, p: 22, c: 5, f: 10, cat: "protein", diets: ["plant"] },
    { name: "Tempeh", key: "Tofu", serving: "150g", amountBase: 150, unit: "g", cal: 290, p: 30, c: 14, f: 15, cat: "protein", diets: ["plant"] },
    { name: "Seitan", key: "Tofu", serving: "150g", amountBase: 150, unit: "g", cal: 220, p: 38, c: 12, f: 2, cat: "protein", diets: ["plant"] },
    { name: "White Rice", key: "Rice", serving: "1 cup cooked", amountBase: 1, unit: "cup", cal: 205, p: 4, c: 45, f: 0, cat: "carb", diets: ["standard", "oldSchool", "budget", "highCarb", "animal", "plant", "picky"] },
    { name: "Potatoes", key: "Potatoes", serving: "300g cooked", amountBase: 300, unit: "g", cal: 260, p: 7, c: 60, f: 0, cat: "carb", diets: ["standard", "oldSchool", "budget", "highCarb", "animal", "plant", "picky"] },
    { name: "Oats", key: "Oats", serving: "80g dry", amountBase: 80, unit: "g", cal: 300, p: 10, c: 54, f: 6, cat: "carb", diets: ["standard", "oldSchool", "budget", "highCarb", "plant", "picky"] },
    { name: "Banana", key: "Fruit", serving: "1 medium", amountBase: 1, unit: "banana", cal: 105, p: 1, c: 27, f: 0, cat: "carb", diets: ["standard", "budget", "highCarb", "animal", "plant", "picky"] },
    { name: "Blueberries", key: "Fruit", serving: "1 cup", amountBase: 1, unit: "cup", cal: 85, p: 1, c: 21, f: 0, cat: "carb", diets: ["standard", "highCarb", "animal", "plant"] },
    { name: "Apple", key: "Fruit", serving: "1 apple", amountBase: 1, unit: "apple", cal: 95, p: 0, c: 25, f: 0, cat: "carb", diets: ["standard", "highCarb", "animal", "plant", "picky"] },
    { name: "Beans", key: "Beans", serving: "1 cup cooked", amountBase: 1, unit: "cup", cal: 225, p: 15, c: 40, f: 1, cat: "carb", diets: ["budget", "plant"] },
    { name: "Lentils", key: "Beans", serving: "1 cup cooked", amountBase: 1, unit: "cup", cal: 230, p: 18, c: 40, f: 1, cat: "carb", diets: ["plant"] },
    { name: "Whole Milk", key: "Milk", serving: "1 cup", amountBase: 1, unit: "cup", cal: 150, p: 8, c: 12, f: 8, cat: "carb", diets: ["standard", "budget", "animal", "picky"] },
    { name: "Honey", key: "Fruit", serving: "1 tbsp", amountBase: 1, unit: "tbsp", cal: 64, p: 0, c: 17, f: 0, cat: "carb", diets: ["highCarb", "animal"] },
    { name: "Olive Oil", key: "Oil", serving: "1 tbsp", amountBase: 1, unit: "tbsp", cal: 120, p: 0, c: 0, f: 14, cat: "fat", diets: ["standard", "oldSchool", "highCarb", "lowCarb", "plant"] },
    { name: "Butter", key: "Butter", serving: "1 tbsp", amountBase: 1, unit: "tbsp", cal: 102, p: 0, c: 0, f: 12, cat: "fat", diets: ["standard", "oldSchool", "budget", "lowCarb", "animal", "picky"] },
    { name: "Avocado", key: "Fruit", serving: "1/2 avocado", amountBase: 0.5, unit: "avocado", cal: 160, p: 2, c: 8, f: 15, cat: "fat", diets: ["standard", "lowCarb", "plant"] },
    { name: "Peanut Butter", key: "Peanut Butter", serving: "2 tbsp", amountBase: 2, unit: "tbsp", cal: 190, p: 8, c: 7, f: 16, cat: "fat", diets: ["standard", "budget", "plant", "picky"] },
    { name: "Almonds", key: "Nuts", serving: "1 oz", amountBase: 1, unit: "oz", cal: 165, p: 6, c: 6, f: 14, cat: "fat", diets: ["standard", "lowCarb", "plant"] }
  ];

  const dietLabels = {
    standard: "Bar Benders Standard",
    oldSchool: "Old School Bodybuilder",
    budget: "Budget Bodybuilder",
    highCarb: "High Carb Performance",
    lowCarb: "Low Carb Bodybuilder",
    animal: "Animal-Based",
    plant: "Plant-Based Bodybuilder",
    picky: "Simple Picky Eater"
  };

  const screens = Array.from(root.querySelectorAll(".bbmp-screen"));
  const nextBtn = root.querySelector("#bbmp-next");
  const backBtn = root.querySelector("#bbmp-back");
  const progressFill = root.querySelector("#bbmp-progress-fill");
  const stepLabel = root.querySelector("#bbmp-step-label");
  const resultsEl = root.querySelector("#bbmp-results");
  const savedBanner = root.querySelector("#bbmp-saved-banner");

  function init() {
    renderFoodChips();
    bindEvents();
    setDefaults();
    updateGoalFields();

    const saved = getSaved();

    if (isUsableSavedPlan(saved)) {
      savedBanner.hidden = false;
    } else {
      savedBanner.hidden = true;
      clearSaved();
    }

    renderStep();
  }

  function isUsableSavedPlan(saved) {
    return !!(
      saved &&
      typeof saved === "object" &&
      saved.result &&
      saved.result.macros &&
      Array.isArray(saved.result.meals) &&
      saved.result.meals.length > 0 &&
      saved.goal &&
      saved.currentWeight &&
      saved.diet
    );
  }

  function setDefaults() {
    selectButton("bodyFat", state.bodyFat);
    selectButton("activity", state.activity);
    selectButton("diet", state.diet);
    selectButton("prep", state.prep);
  }

  function bindEvents() {
    root.addEventListener("click", function (e) {
      const choice = e.target.closest("[data-choice]");
      if (!choice || !root.contains(choice)) return;

      const type = choice.dataset.choice;
      const value = choice.dataset.value;

      if (type === "goal") {
        state.goal = value;
        selectButton(type, value);
        updateGoalFields();
      }

      if (type === "bodyFat") {
        state.bodyFat = value;
        selectButton(type, value);
      }

      if (type === "activity") {
        state.activity = value;
        selectButton(type, value);
      }

      if (type === "diet") {
        state.diet = value;
        selectButton(type, value);
      }

      if (type === "prep") {
        state.prep = value;
        selectButton(type, value);
      }
    });

    nextBtn.addEventListener("click", function () {
      if (!validateStep()) return;

      collectInputs();

      if (state.step === 3) {
        state.result = buildPlan();
        saveState();
        renderResults();
        state.step = 4;
      } else if (state.step === 4) {
        state.result = buildPlan();
        saveState();
        renderResults();
      } else {
        state.step += 1;
      }

      renderStep();
    });

    backBtn.addEventListener("click", function () {
      if (state.step > 0) state.step -= 1;
      renderStep();
    });

    root.querySelector("#bbmp-start-over-top").addEventListener("click", resetAll);

    root.querySelector("#bbmp-clear-saved").addEventListener("click", function () {
      resetAll();
    });

    root.querySelector("#bbmp-continue-saved").addEventListener("click", function () {
      const saved = getSaved();

      if (isUsableSavedPlan(saved)) {
        loadSaved(saved);
        savedBanner.hidden = true;
      } else {
        clearSaved();
        savedBanner.hidden = true;
        resetAll();
      }
    });

    ["bbmp-current-weight", "bbmp-goal-weight", "bbmp-training-days", "bbmp-meal-count"].forEach(function (id) {
      const el = root.querySelector("#" + id);
      if (!el) return;

      el.addEventListener("input", function () {
        collectInputs();
      });

      el.addEventListener("change", function () {
        collectInputs();
      });
    });
  }

  function renderFoodChips() {
    const include = root.querySelector("#bbmp-include-foods");
    const avoid = root.querySelector("#bbmp-avoid-foods");

    include.innerHTML = "";
    avoid.innerHTML = "";

    foodChips.forEach(function (food) {
      include.appendChild(chipButton(food, "include"));
      avoid.appendChild(chipButton(food, "avoid"));
    });
  }

  function chipButton(food, type) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "bbmp-chip";
    btn.textContent = food;
    btn.dataset.food = food;
    btn.dataset.type = type;

    btn.addEventListener("click", function () {
      const arr = type === "include" ? state.includeFoods : state.avoidFoods;
      const other = type === "include" ? state.avoidFoods : state.includeFoods;

      toggleInArray(arr, food);

      const otherIndex = other.indexOf(food);
      if (arr.includes(food) && otherIndex > -1) other.splice(otherIndex, 1);

      renderChipSelections();
    });

    return btn;
  }

  function renderChipSelections() {
    root.querySelectorAll(".bbmp-chip").forEach(function (btn) {
      const arr = btn.dataset.type === "include" ? state.includeFoods : state.avoidFoods;
      btn.classList.toggle("selected", arr.includes(btn.dataset.food));
    });
  }

  function toggleInArray(arr, value) {
    const i = arr.indexOf(value);

    if (i > -1) {
      arr.splice(i, 1);
    } else {
      arr.push(value);
    }
  }

  function selectButton(type, value) {
    root.querySelectorAll('[data-choice="' + type + '"]').forEach(function (btn) {
      btn.classList.toggle("selected", btn.dataset.value === value);
    });
  }

  function collectInputs() {
    state.currentWeight = root.querySelector("#bbmp-current-weight").value;
    state.goalWeight = root.querySelector("#bbmp-goal-weight").value;
    state.trainingDays = root.querySelector("#bbmp-training-days").value;
    state.mealCount = root.querySelector("#bbmp-meal-count").value;
  }

  function updateGoalFields() {
    const isBulk = state.goal === "bulk";
    const isCut = state.goal === "cut";

    root.querySelectorAll(".bbmp-bulk-only").forEach(function (el) {
      el.style.display = isBulk ? "block" : "none";
    });

    root.querySelectorAll(".bbmp-cut-only").forEach(function (el) {
      el.style.display = isCut ? "block" : "none";
    });
  }

  function renderStep() {
    screens.forEach(function (screen, idx) {
      screen.classList.toggle("active", idx === state.step);
    });

    progressFill.style.width = ((state.step + 1) / screens.length * 100) + "%";
    stepLabel.textContent = "Step " + (state.step + 1) + " of " + screens.length;
    backBtn.disabled = state.step === 0;

    if (state.step === 3) {
      nextBtn.textContent = "Build Plan";
    } else if (state.step === 4) {
      nextBtn.textContent = "Update Plan";
    } else {
      nextBtn.textContent = "Continue";
    }

    if (state.step === 4 && state.result) {
      renderResults();
    }

    const shell = root.querySelector(".bbmp-shell");
    if (shell) {
      shell.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }

  function showError(message) {
    let err = root.querySelector(".bbmp-error");

    if (!err) {
      err = document.createElement("div");
      err.className = "bbmp-error";
      screens[state.step].appendChild(err);
    }

    err.textContent = message;
    err.style.display = "block";

    setTimeout(function () {
      err.style.display = "none";
    }, 2800);
  }

  function validateStep() {
    collectInputs();

    if (state.step === 0 && !state.goal) {
      showError("Choose bulk or cut first.");
      return false;
    }

    if (state.step === 1) {
      if (!num(state.currentWeight)) {
        showError("Enter your current bodyweight.");
        return false;
      }

      if (state.goal === "bulk" && !num(state.goalWeight)) {
        showError("Enter your goal bodyweight for the bulk.");
        return false;
      }

      if (state.goal === "bulk" && num(state.goalWeight) < num(state.currentWeight)) {
        showError("Goal bodyweight should be higher than current bodyweight for a bulk.");
        return false;
      }
    }

    if (state.step === 2 && !state.diet) {
      showError("Choose a diet style.");
      return false;
    }

    return true;
  }

  function num(value) {
    return Number(value || 0);
  }

  function calculateMacros() {
    const currentWeight = num(state.currentWeight);
    const goalWeight = num(state.goalWeight);
    const activity = CONFIG.activity[state.activity] || CONFIG.activity.moderate;

    let baseCalories = 0;
    let protein = 0;

    const macroWeight = state.goal === "bulk" ? goalWeight : currentWeight;

    if (state.goal === "cut") {
      protein = Math.round(currentWeight);

      const cutMultiplier =
        state.bodyFat === "30+" ? 10 :
        state.bodyFat === "20-30" ? 11 :
        12;

      baseCalories = currentWeight * cutMultiplier;
    } else {
      protein = Math.round(goalWeight);
      baseCalories = goalWeight * CONFIG.bulkBaseMultiplier;
    }

    let calories = Math.round(baseCalories * activity.multiplier);
    let fat = 0;
    let carbs = 0;

    if (state.diet === "lowCarb") {
      carbs = state.goal === "cut" ? 75 : 125;
      fat = Math.round((calories - (protein * 4) - (carbs * 4)) / 9);
    } else {
      let fatMultiplier = 0.30;

      if (state.goal === "bulk") fatMultiplier = 0.35;
      if (state.diet === "oldSchool" || state.diet === "highCarb" || state.diet === "plant") fatMultiplier = 0.25;
      if (state.diet === "animal") fatMultiplier = 0.40;
      if (state.diet === "picky" || state.diet === "budget" || state.diet === "standard") {
        fatMultiplier = state.goal === "bulk" ? 0.35 : 0.30;
      }

      fat = Math.round(macroWeight * fatMultiplier);

      if (state.goal === "cut") fat = Math.max(fat, 45);
      if (state.goal === "bulk") fat = Math.max(fat, 55);

      carbs = Math.round((calories - (protein * 4) - (fat * 9)) / 4);
    }

    if (carbs < 40) {
      carbs = 40;
      fat = Math.max(40, Math.round((calories - (protein * 4) - (carbs * 4)) / 9));
    }

    if (fat < 35) fat = 35;

    calories = Math.round((protein * 4) + (carbs * 4) + (fat * 9));

    return {
      calories: calories,
      protein: protein,
      carbs: carbs,
      fat: fat,
      activityLabel: activity.label,
      baseCalories: Math.round(baseCalories),
      activityMultiplier: activity.multiplier
    };
  }

  function buildPlan() {
    const macros = calculateMacros();
    const mealCount = Number(state.mealCount);
    const distributions = getDistribution(mealCount);
    const selectedFoods = getFoodsForDiet();
    const meals = [];

    for (let i = 0; i < mealCount; i++) {
      const d = distributions[i];

      const target = {
        p: macros.protein * d.p,
        c: macros.carbs * d.c,
        f: macros.fat * d.f
      };

      meals.push(buildMeal(i, target, selectedFoods));
    }

    const grocery = buildGrocery(meals);

    return {
      macros: macros,
      meals: meals,
      grocery: grocery,
      coachNote: getCoachNote(),
      created: new Date().toLocaleDateString()
    };
  }

  function getDistribution(mealCount) {
    const base = Array.from({ length: mealCount }, function () {
      return {
        p: 1 / mealCount,
        c: 1 / mealCount,
        f: 1 / mealCount
      };
    });

    if (mealCount === 5 && state.goal === "cut") {
      return [
        { p: .20, c: .18, f: .22 },
        { p: .20, c: .22, f: .18 },
        { p: .20, c: .22, f: .18 },
        { p: .20, c: .20, f: .20 },
        { p: .20, c: .18, f: .22 }
      ];
    }

    if (mealCount === 5 && state.goal === "bulk") {
      return [
        { p: .20, c: .20, f: .20 },
        { p: .20, c: .20, f: .20 },
        { p: .20, c: .22, f: .18 },
        { p: .20, c: .22, f: .18 },
        { p: .20, c: .16, f: .24 }
      ];
    }

    return base;
  }

  function getFoodsForDiet() {
    let allowed = foods.filter(function (f) {
      return f.diets.includes(state.diet);
    });

    if (state.avoidFoods.length) {
      allowed = allowed.filter(function (f) {
        return !state.avoidFoods.includes(f.key);
      });
    }

    if (state.includeFoods.length) {
      const included = foods.filter(function (f) {
        return state.includeFoods.includes(f.key) &&
          f.diets.includes(state.diet) &&
          !state.avoidFoods.includes(f.key);
      });

      allowed = uniqueFoods(included.concat(allowed));
    }

    if (!allowed.some(function (f) { return f.cat === "protein"; })) {
      allowed = allowed.concat(foods.filter(function (f) {
        return f.cat === "protein" && f.diets.includes("standard");
      }));
    }

    if (!allowed.some(function (f) { return f.cat === "carb"; })) {
      allowed = allowed.concat(foods.filter(function (f) {
        return f.cat === "carb" && f.diets.includes("standard");
      }));
    }

    if (!allowed.some(function (f) { return f.cat === "fat"; })) {
      allowed = allowed.concat(foods.filter(function (f) {
        return f.cat === "fat" && f.diets.includes("standard");
      }));
    }

    return uniqueFoods(allowed);
  }

  function uniqueFoods(list) {
    const seen = new Set();

    return list.filter(function (food) {
      const key = food.name;

      if (seen.has(key)) return false;

      seen.add(key);
      return true;
    });
  }

  function pick(list, idx) {
    if (!list.length) return null;

    if (state.prep === "mealPrep" || state.prep === "cheap" || state.diet === "picky") {
      return list[idx % Math.min(list.length, 3)];
    }

    return list[idx % list.length];
  }

  function buildMeal(index, target, selectedFoods) {
    const proteins = selectedFoods.filter(function (f) { return f.cat === "protein"; });
    const carbs = selectedFoods.filter(function (f) { return f.cat === "carb"; });
    const fats = selectedFoods.filter(function (f) { return f.cat === "fat"; });

    const proteinFood = pick(proteins, index);
    const carbFood = state.diet === "lowCarb" ? pick(carbs, index + 2) : pick(carbs, index);
    const fatFood = pick(fats, index);

    const items = [];

    if (proteinFood) items.push(portionFor(proteinFood, target.p, "p"));
    if (carbFood && target.c > 8) items.push(portionFor(carbFood, target.c, "c"));

    const current = sumItems(items);
    const fatNeed = Math.max(target.f - current.f, 0);

    if (fatFood && fatNeed > 4) {
      items.push(portionFor(fatFood, fatNeed, "f"));
    }

    const totals = sumItems(items);

    return {
      name: "Meal " + (index + 1),
      items: items,
      totals: totals
    };
  }

  function portionFor(food, targetMacro, macroKey) {
    const macroPerServing = food[macroKey] || 1;
    let multiplier = targetMacro / macroPerServing;

    if (!isFinite(multiplier) || multiplier <= 0) multiplier = 1;

    multiplier = Math.max(0.35, Math.min(multiplier, 4));
    multiplier = roundNice(multiplier);

    const amount = roundAmount(food.amountBase * multiplier, food.unit);

    return {
      name: food.name,
      amount: amount,
      unit: food.unit,
      serving: food.serving,
      cal: Math.round(food.cal * multiplier),
      p: Math.round(food.p * multiplier),
      c: Math.round(food.c * multiplier),
      f: Math.round(food.f * multiplier)
    };
  }

  function roundNice(value) {
    return Math.round(value * 4) / 4;
  }

  function roundAmount(value, unit) {
    if (["egg", "eggs", "banana", "apple", "can", "scoop"].includes(unit)) {
      return Math.max(1, Math.round(value * 2) / 2);
    }

    if (["cup", "tbsp", "avocado", "oz"].includes(unit)) {
      return Math.round(value * 4) / 4;
    }

    return Math.round(value / 5) * 5;
  }

  function sumItems(items) {
    return items.reduce(function (total, item) {
      total.cal += item.cal;
      total.p += item.p;
      total.c += item.c;
      total.f += item.f;
      return total;
    }, {
      cal: 0,
      p: 0,
      c: 0,
      f: 0
    });
  }

  function buildGrocery(meals) {
    const grocery = {};

    meals.forEach(function (meal) {
      meal.items.forEach(function (item) {
        const key = item.name + "|" + item.unit;

        if (!grocery[key]) {
          grocery[key] = {
            name: item.name,
            amount: 0,
            unit: item.unit
          };
        }

        grocery[key].amount += Number(item.amount);
      });
    });

    return Object.values(grocery).map(function (item) {
      return {
        name: item.name,
        amount: roundAmount(item.amount, item.unit),
        unit: item.unit
      };
    });
  }

  function getCoachNote() {
    if (state.goal === "cut") {
      return "Hit the protein, follow the meals, and do not turn hunger into random snacking. If progress stalls, adjust the plan after you have followed it honestly.";
    }

    return "Push food with structure. The goal is size, not using a bulk as permission to eat garbage. Train hard, track the scale, and stay consistent.";
  }

  function renderResults() {
    if (!state.result) return;

    const r = state.result;

    resultsEl.innerHTML = `
      <div class="bbmp-macro-grid">
        <div class="bbmp-macro-card">
          <small>Calories</small>
          <strong>${r.macros.calories}</strong>
        </div>
        <div class="bbmp-macro-card">
          <small>Protein</small>
          <strong>${r.macros.protein}g</strong>
        </div>
        <div class="bbmp-macro-card">
          <small>Carbs</small>
          <strong>${r.macros.carbs}g</strong>
        </div>
        <div class="bbmp-macro-card">
          <small>Fat</small>
          <strong>${r.macros.fat}g</strong>
        </div>
        <div class="bbmp-macro-card">
          <small>Meals</small>
          <strong>${state.mealCount}</strong>
        </div>
      </div>

      <div class="bbmp-result-layout">
        <div class="bbmp-panel">
          <h4>Daily Meal Plan</h4>
          ${r.meals.map(renderMeal).join("")}
        </div>

        <div class="bbmp-panel">
          <h4>Export Plan</h4>

          <div class="bbmp-action-grid">
            <button type="button" class="bbmp-btn" id="bbmp-print">Print or Save PDF</button>
            <button type="button" class="bbmp-ghost" id="bbmp-copy">Copy Plan</button>
            <button type="button" class="bbmp-ghost" id="bbmp-csv">Download CSV</button>
            <button type="button" class="bbmp-ghost" id="bbmp-grocery-copy">Copy Grocery List</button>
          </div>

          <div style="height:18px"></div>

          <h4>Grocery List</h4>
          <ul class="bbmp-grocery-list">
            ${r.grocery.map(function (g) {
              return "<li>" + formatAmount(g.amount) + " " + g.unit + " " + escapeHtml(g.name) + "</li>";
            }).join("")}
          </ul>

          <div style="height:18px"></div>

          <h4>Coach Note</h4>
          <p class="bbmp-note">${escapeHtml(r.coachNote)}</p>

          <details class="bbmp-audit">
            <summary>Macro Audit</summary>
            <div>
              Goal: ${capitalize(state.goal)}<br>
              Current Bodyweight: ${state.currentWeight} lb<br>
              ${state.goal === "bulk" ? "Goal Bodyweight: " + state.goalWeight + " lb<br>" : ""}
              Diet Style: ${dietLabels[state.diet]}<br>
              Activity: ${r.macros.activityLabel}<br>
              Training Days: ${state.trainingDays} per week<br>
              Created: ${r.created}
            </div>
          </details>
        </div>
      </div>
    `;

    bindResultButtons();
  }

  function renderMeal(meal) {
    return `
      <div class="bbmp-meal-card">
        <div class="bbmp-meal-top">
          <strong>${meal.name}</strong>
          <span>${meal.totals.cal} cal</span>
        </div>

        <ul class="bbmp-food-list">
          ${meal.items.map(function (item) {
            return `
              <li>
                <span>${formatAmount(item.amount)} ${item.unit} ${escapeHtml(item.name)}</span>
                <small>${item.p}P / ${item.c}C / ${item.f}F</small>
              </li>
            `;
          }).join("")}
        </ul>

        <div class="bbmp-meal-macros">
          ${meal.totals.p}g protein / ${meal.totals.c}g carbs / ${meal.totals.f}g fat / ${meal.totals.cal} calories
        </div>
      </div>
    `;
  }

  function bindResultButtons() {
    const printBtn = root.querySelector("#bbmp-print");
    const copyBtn = root.querySelector("#bbmp-copy");
    const csvBtn = root.querySelector("#bbmp-csv");
    const groceryBtn = root.querySelector("#bbmp-grocery-copy");

    if (printBtn) {
      printBtn.addEventListener("click", function () {
        window.print();
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        copyText(planText());
        toast("Plan copied.");
      });
    }

    if (csvBtn) {
      csvBtn.addEventListener("click", downloadCsv);
    }

    if (groceryBtn) {
      groceryBtn.addEventListener("click", function () {
        copyText(groceryText());
        toast("Grocery list copied.");
      });
    }
  }

  function planText() {
    const r = state.result;

    let text = "Bar Benders Meal Plan\n\n";

    text += "Calories: " + r.macros.calories + "\n";
    text += "Protein: " + r.macros.protein + "g\n";
    text += "Carbs: " + r.macros.carbs + "g\n";
    text += "Fat: " + r.macros.fat + "g\n";
    text += "Meals: " + state.mealCount + "\n";
    text += "Diet: " + dietLabels[state.diet] + "\n\n";

    r.meals.forEach(function (meal) {
      text += meal.name + "\n";

      meal.items.forEach(function (item) {
        text += "- " + formatAmount(item.amount) + " " + item.unit + " " + item.name + "\n";
      });

      text += meal.totals.p + "g protein / " + meal.totals.c + "g carbs / " + meal.totals.f + "g fat / " + meal.totals.cal + " calories\n\n";
    });

    text += "Grocery List\n" + groceryText() + "\n\n";
    text += "Coach Note\n" + r.coachNote;

    return text;
  }

  function groceryText() {
    return state.result.grocery.map(function (g) {
      return formatAmount(g.amount) + " " + g.unit + " " + g.name;
    }).join("\n");
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
  }

  function downloadCsv() {
    const rows = [
      ["Meal", "Food", "Amount", "Unit", "Calories", "Protein", "Carbs", "Fat"]
    ];

    state.result.meals.forEach(function (meal) {
      meal.items.forEach(function (item) {
        rows.push([
          meal.name,
          item.name,
          item.amount,
          item.unit,
          item.cal,
          item.p,
          item.c,
          item.f
        ]);
      });
    });

    const csv = rows.map(function (row) {
      return row.map(function (cell) {
        return '"' + String(cell).replace(/"/g, '""') + '"';
      }).join(",");
    }).join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = "bar-benders-meal-plan.csv";
    a.click();

    URL.revokeObjectURL(url);
  }

  function toast(message) {
    const old = root.querySelector(".bbmp-toast");
    if (old) old.remove();

    const t = document.createElement("div");
    t.className = "bbmp-toast";
    t.textContent = message;

    t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#111;color:#fff;border:1px solid rgba(255,255,255,.18);border-radius:999px;padding:12px 18px;font-weight:900;z-index:999999;box-shadow:0 18px 50px rgba(0,0,0,.35);";

    document.body.appendChild(t);

    setTimeout(function () {
      t.remove();
    }, 1800);
  }

  function saveState() {
    try {
      localStorage.setItem(CONFIG.saveKey, JSON.stringify(state));
    } catch (e) {}
  }

  function getSaved() {
    try {
      return JSON.parse(localStorage.getItem(CONFIG.saveKey));
    } catch (e) {
      return null;
    }
  }

  function clearSaved() {
    try {
      localStorage.removeItem(CONFIG.saveKey);
      localStorage.removeItem("bbMealPlanBuilderV1");
    } catch (e) {}
  }

  function loadSaved(saved) {
    Object.assign(state, saved);

    root.querySelector("#bbmp-current-weight").value = state.currentWeight || "";
    root.querySelector("#bbmp-goal-weight").value = state.goalWeight || "";
    root.querySelector("#bbmp-training-days").value = state.trainingDays || "5";
    root.querySelector("#bbmp-meal-count").value = state.mealCount || "5";

    ["goal", "bodyFat", "activity", "diet", "prep"].forEach(function (k) {
      selectButton(k, state[k]);
    });

    renderChipSelections();
    updateGoalFields();

    state.step = 4;

    renderStep();
  }

  function resetAll() {
    clearSaved();

    Object.assign(state, {
      step: 0,
      goal: "",
      currentWeight: "",
      goalWeight: "",
      bodyFat: "20-30",
      activity: "moderate",
      trainingDays: "5",
      mealCount: "5",
      diet: "standard",
      includeFoods: [],
      avoidFoods: [],
      prep: "mealPrep",
      result: null
    });

    root.querySelector("#bbmp-current-weight").value = "";
    root.querySelector("#bbmp-goal-weight").value = "";
    root.querySelector("#bbmp-training-days").value = "5";
    root.querySelector("#bbmp-meal-count").value = "5";

    root.querySelectorAll(".selected").forEach(function (el) {
      el.classList.remove("selected");
    });

    setDefaults();
    updateGoalFields();
    renderChipSelections();

    savedBanner.hidden = true;

    renderStep();
  }

  function formatAmount(value) {
    if (Number.isInteger(value)) return String(value);
    return String(Math.round(value * 100) / 100).replace(/\.00$/, "");
  }

  function capitalize(str) {
    return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>'"]/g, function (char) {
      if (char === "&") return "&amp;";
      if (char === "<") return "&lt;";
      if (char === ">") return "&gt;";
      if (char === "'") return "&#039;";
      if (char === '"') return "&quot;";
      return char;
    });
  }

  init();
})();